import { EdhProtocolCombination } from "../services/data-list/get-edh-protocol-combination-list/GetEdhProtocolCombinationListResponse";
import { Option } from "../util/option";
import { InDefCommonFlagType } from "./general-code/enums/general-codes";

const EDH_PROTOCOL_LABEL_DELIMITER = "/";

export const isChecked = (value: string) => value === InDefCommonFlagType.YES;

type EdhPrtcl = {
  inOutTypeCd: string;
  edhPrtclTypeCd: string;
};
export type CreateDynamicEdhProtocol = {
  edhProtocolCombinationList: EdhProtocolCombination[];
  edhProtocolList: Option[];
  edhProtocolCheckList: string[];
};

/**
 * createDynamicEdhProtocol
 */
export const createDynamicEdhProtocol: (props: CreateDynamicEdhProtocol) => {
  dynamicEdhProtocolList: Option[];
  edhProtocolCheckList: string[];
} = (props: CreateDynamicEdhProtocol) => {
  const {
    edhProtocolCombinationList,
    edhProtocolList,
    edhProtocolCheckList: checkedPrtclList,
  } = props;

  if (checkedPrtclList.length == 0) {
    return {
      dynamicEdhProtocolList: edhProtocolList,
      edhProtocolCheckList: [],
    };
  }

  const possiblePrtclList: EdhPrtcl[] = checkedPrtclList
    .map((checkedPrtcl) => {
      const [checkedIOTypeCd, checkedPrtclTypeCd] = checkedPrtcl.split(
        EDH_PROTOCOL_LABEL_DELIMITER,
      );

      const possibleEdhPrtcl = edhProtocolCombinationList
        .filter(
          (e) =>
            checkedIOTypeCd === e.inOutTypeCd1 &&
            checkedPrtclTypeCd === e.edhPrtclTypeCd1,
        )
        .map((e) => ({
          inOutTypeCd: e.inOutTypeCd2,
          edhPrtclTypeCd: e.edhPrtclTypeCd2,
        }));

      if (possibleEdhPrtcl.length < 1)
        return [
          {
            inOutTypeCd: checkedIOTypeCd,
            edhPrtclTypeCd: checkedPrtclTypeCd,
          },
        ];

      return [
        {
          inOutTypeCd: checkedIOTypeCd,
          edhPrtclTypeCd: checkedPrtclTypeCd,
        },
        ...possibleEdhPrtcl,
      ];
    })
    .reduce((prev, current) => {
      return prev.filter((pe) =>
        current.some(
          (ce) =>
            pe.inOutTypeCd === ce.inOutTypeCd &&
            pe.edhPrtclTypeCd === ce.edhPrtclTypeCd,
        ),
      );
    });

  const newDynamicEdhProtocolList: Option[] = edhProtocolList.filter(
    (edhProtcol) =>
      possiblePrtclList.some(
        (e) =>
          edhProtcol.value ===
          e.inOutTypeCd + EDH_PROTOCOL_LABEL_DELIMITER + e.edhPrtclTypeCd,
      ),
  );

  return {
    dynamicEdhProtocolList: newDynamicEdhProtocolList,
    edhProtocolCheckList: checkedPrtclList,
  };
};
